export const generateListBadgesData = (
  max: number,

  nbrAnnules: number,
  nbrClotures: number,
  nbrEnAttente: number,
  nbrEnCours: number,
  nbrNonResolu: number,
  nbrResolus: number,
  nbrOuverts: number,
): any[] => {
  return [
    {
      text: 'Tickets',
      number: max,
      textColor: '#667085',
      numberColor: '#4964C1',
      backgroundColor: 'white',
    },
    {
      text: 'Nouveau',
      number: nbrOuverts, 
      textColor: '#3538CD',
      numberColor: '#3538CD',
      backgroundColor: '#EEF4FF',
      statut: 0
    },
    {
      text: 'En cours',
      number: nbrEnCours, 
      textColor: '#357BCD',
      numberColor: '#357BCD',
      backgroundColor: '#EEF4FF',
      statut: 2
    },
    {
      text: 'En attente',
      number: nbrEnAttente, 
      textColor: '#B54708',
      numberColor: '#B54708',
      backgroundColor: '#FFFAEB',
      statut: 1
    },
    {
      text: 'Résolu',
      number: nbrResolus,
      textColor: '#027A48',
      numberColor: '#027A48',
      backgroundColor: '#ECFDF3',
      statut: 3
    },
    {
      text: 'Non Résolu',
      number: nbrNonResolu,
      textColor: '#FA3E3E',
      numberColor: '#FA3E3E',
      backgroundColor: 'rgba(250, 62, 62, 0.17)',
      statut: 4
    },
    {
      text: 'Clôturé(s)',
      number: nbrClotures, 
      textColor: '#363F72',
      numberColor: '#363F72',
      backgroundColor: '#F2F4F7',
      statut: 6
    },
    // {
    //   text: 'Annulé',
    //   number: nbrAnnules, 
    //   textColor: '#D32828',
    //   numberColor: '#D32828',
    //   backgroundColor: '#FFF0F0',
    //   statut: 5
    // },
  ];
};


export const generateBadgeColor = (
  status: string,
): {textColor: string; backgroundColor: string} => {
  let textColor = '#000'; // Default text color
  let backgroundColor = '#FFF'; // Default background color

  switch (status.toLowerCase()) {
    case 'résolu':
      textColor = '#027A48';
      backgroundColor = '#ECFDF3';
      break;
    case 'ouvert':
      textColor = '#3538CD';
      backgroundColor = '#EEF4FF';
      break;
    case 'non résolu':
      textColor = '#FA3E3E';
      backgroundColor = 'rgba(250, 62, 62, 0.17)';
      break;
    case 'en attente':
      textColor = '#B54708';
      backgroundColor = '#FFFAEB';
      break;

    case 'clôturé':
      textColor = '#363F72';
      backgroundColor = '#F2F4F7';
      break;
    case 'en cours':
      textColor = '#357BCD';
      backgroundColor = '#EEF4FF';
      break;
    // case 'annulé':
    //   textColor = '#D32828';
    //   backgroundColor = '#FFF0F0';
    //   break;
    default:
      break;
  }

  return {textColor, backgroundColor};
};

export const getSubCategories = (SAVCategories: { [key: string]: string[] }, category: string): string[] => {
  return SAVCategories[category] || [];
}